module.exports = __webpack_public_path__ + "media/old_images/location-blue-bb028054.svg";